module.exports = __webpack_public_path__ + "img/bio--white.b8c635a9.svg";